import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  ViewData,
  ViewDataWithSection,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getMultiSectionFigmaLayout } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import { DISPLACE_GAP } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/shelfDisplay.figma';
import { isOdd } from '@Utils/miscUtils';

/** Applies small displace gaps on even or odd columns and optionally withing specific columns range*/
export function addShelfDisplaceGaps(
  indexCheck: (index: number) => boolean = isOdd,
  slice?: [number, number | undefined]
): (viewData: ViewDataWithSection) => Promise<ViewData> {
  return async (viewData: ViewDataWithSection): Promise<ViewData> => {
    // apply default slice limits
    const [start, finish = viewData.layoutTable!.length] = slice ?? [
      0,
      viewData.layoutTable!.length,
    ];

    const gap =
      getMultiSectionFigmaLayout(viewData) === 'full'
        ? DISPLACE_GAP
        : DISPLACE_GAP / 2;

    viewData.layoutTable!.slice(start, finish).forEach((column, index) => {
      if (indexCheck(index)) {
        column.push(
          getGap({
            width: viewData.columnWidth!,
            height: gap,
          })
        );
      }
    });

    return viewData;
  };
}
